var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.getQuote},[_vm._v("Need to move"),_c('br'),_vm._v("anything anywhere?"),_c('a',{attrs:{"id":"getQuoteBtn","href":`${this.$config.v4Host}/categories`}},[_vm._v("Get Instant Quotes")])])
}
var staticRenderFns = []

export { render, staticRenderFns }